import { Component, Input } from '@angular/core';
import { Note } from '@usf/alert-types';
import { Crumb } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { PageTitle } from '../../../shared/constants/page-titles.enum';
import { PlatformService } from '@panamax/app-state';

@Component({
  selector: 'app-note-header',
  templateUrl: './note-header.component.html',
  styleUrls: ['./note-header.component.scss'],
})
export class NoteHeaderComponent {
  breadcrumbs: Crumb[];
  @Input() note: Note;

  constructor(readonly platformService: PlatformService) {
    this.breadcrumbs = [
      {
        label: 'i18n.breadcrumbs.home',
        url: '/desktop/home',
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.notifications',
        url: '/notifications',
        active: false,
      },
      {
        label: 'i18n.breadcrumbs.noteDetails',
        url: '',
        active: true,
      },
    ];
  }
}
